import { Dialog, DialogContent, DialogActions, DialogTitle, Divider } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '../new/Button';
import { Typography } from '../new/Typography';

interface UnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({ open, onClose, onSave, onDiscard }) => {
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          background: '#ffffff',
          minWidth: '37.5rem',
        },
      }}
    >
      <DialogTitle>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ color: '#140838', fontSize: '1.125rem', fontWeight: 500 }}>
            Save changes before leaving?
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={14}>You have unsaved changes. Save your document edits now, or discard all changes to leave.</Typography>
      </DialogContent>
      <Divider sx={{ color: '#D6D6D6' }} />
      <DialogActions sx={{ padding: '1rem 1.5rem', paddingLeft: '40%', alignItems: 'center' }}>
        <span
          onClick={onDiscard}
          style={{
            color: '#AC3737',
            fontSize: '0.875rem',
            fontWeight: 600,
            textDecoration: 'underline',
            cursor: 'pointer',
            fontFamily: 'Instrument Sans',
            whiteSpace: 'nowrap',
          }}
        >
          Discard Changes
        </span>
        <Button type="primary" sx={{ whiteSpace: 'nowrap', width: 'auto', padding: '0.625rem 1.5rem' }} onClick={onSave}>
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
